import { AppPage } from "../utils/AppPage";
import { Calendar } from "./Calendar";
import { useStore } from "../store/StoreProvider";
import { useCallback } from "react";
import { useAPI } from "../api/useAPI";
import { useGetAccounts } from "../utils/useGetAccounts";

export const SchedulePage = () => {
  const { state, setState } = useStore();
  const { activityList } = state;
  const api = useAPI();
  const accounts = useGetAccounts();

  const fetchActivity = useCallback(() => {
    api.activityGet({}).then((response) => {
      setState((s) => ({ ...s, activityList: response.activities }));
    });
  }, [api, setState]);

  return (
    <AppPage title="Camp Schedule" padding={0}>
      <Calendar
        activityList={activityList}
        onRefetchList={fetchActivity}
        accounts={accounts}
      />
    </AppPage>
  );
};
